import moment from "moment";
import { useMemo } from "react";
import { AreaComumUnidadeBloqueadaItem } from "../typings";

function useBloqueioAreaComumColumns() {
  return useMemo(() => {
    return [
      {
        title: "Início bloqueio",
        dataIndex: "dataInicio",
        render: (dataInicio: string) => (
          <div>
            {dataInicio ? moment(dataInicio).format("DD/MM/YYYY") : "--"}
          </div>
        ),
      },
      {
        title: "Fim bloqueio",
        dataIndex: "dataFim",
        render: (dataFim: string) => (
          <div>{dataFim ? moment(dataFim).format("DD/MM/YYYY") : "--"}</div>
        ),
      },
      {
        title: "Quem bloqueou",
        render: (original: AreaComumUnidadeBloqueadaItem) => (
          <div>
            {original.usuarioOperador ? original.usuarioOperador.nome : "--"}
          </div>
        ),
      },
      {
        title: "Motivo",
        width: "500px",
        render: (original: AreaComumUnidadeBloqueadaItem) => (
          <div>{original.motivo ? original.motivo : "--"}</div>
        ),
      },
    ];
  }, []);
}

export default useBloqueioAreaComumColumns;
